import { getHomePageApi, getListParkApi, getListPerformanceApi, getListRestaurantApi, getListZoneApi } from 'app/services/homeApi';
import { call, put, takeLatest } from 'redux-saga/effects';
import { GET_HOME, GET_PARKS, GET_PERFORMANCES, GET_RESTAURANTS, GET_ZONES } from '.';

export function* getHome({ payload }: any) {
  try {
    const { data } = yield call(getHomePageApi, payload);
    yield put(GET_HOME.success(data));
  } catch (err) {
    yield put(GET_HOME.failure());
  }
}

export function* getListPark({ payload }: any) {
  try {
    const { data } = yield call(getListParkApi, {
      ...payload,
      limit: 50,
      page: 1,
    });
    yield put(GET_PARKS.success(data.data));
  } catch (err) {
    yield put(GET_PARKS.failure());
  }
}

export function* getListZone({ payload }: any) {
  try {
    const { data } = yield call(getListZoneApi, payload);
    yield put(GET_ZONES.success(data.data));
  } catch (err) {
    yield put(GET_ZONES.failure());
  }
}

export function* getListPerformance({ payload }: any) {
  try {
    const { data } = yield call(getListPerformanceApi, payload);
    yield put(GET_PERFORMANCES.success(data.data));
  } catch (err) {
    yield put(GET_PERFORMANCES.failure());
  }
}

export function* getListRestaurant({ payload }: any) {
  try {
    const { data } = yield call(getListRestaurantApi, payload);
    yield put(GET_RESTAURANTS.success(data.data));
  } catch (err) {
    yield put(GET_RESTAURANTS.failure());
  }
}


export function* homeSaga() {
  yield takeLatest(GET_HOME.TRIGGER, getHome);
  yield takeLatest(GET_PARKS.TRIGGER, getListPark);
  yield takeLatest(GET_ZONES.TRIGGER, getListZone);
  yield takeLatest(GET_PERFORMANCES.TRIGGER, getListPerformance);
  yield takeLatest(GET_RESTAURANTS.TRIGGER, getListRestaurant);
}
